<div class="row">
	<div class="col-lg-12">
		<div class="card" id="blackoutDaysList">
			<div class="card-header border-0">
				<div class="d-flex align-items-center">
					<h5 class="card-title mb-0 flex-grow-1">
						Forecast History
					</h5>
				</div>
			</div>
			<div
				class="card-body border border-dashed border-end-0 border-start-0"
			>
				<div class="margin-top-2">
					<div class="alert alert-info text-center">
						Please select the starting date.
					</div>

					<div class="dropdown" ngbDropdown>
						<!-- <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                            Select Start Week
                        </button> -->
						<div
							class="dropdown-menu"
							aria-labelledby="dropdownMenuButton1"
							ngbDropdownMenu
						>
							<a
								class="dropdown-item"
								href="javascript: void(0);"
								>{{ this.monday_1 }}</a
							>
							<a
								class="dropdown-item"
								href="javascript: void(0);"
								>{{ this.monday_2 }}</a
							>
							<a
								class="dropdown-item"
								href="javascript: void(0);"
								>{{ this.monday_3 }}</a
							>
						</div>
					</div>
					<div #sheet></div>
				</div>
			</div>
		</div>
	</div>
</div>
